import alt from "../alt";

class PassSubscriptionActions {
  constructor() {
    this.generateActions(
      "updatePassSubscriptions",
      "fetchAll",
      "fetchOne",
      "fetchFailed"
    );
  }

  updatePassSubscription(id, passSubscription) {
    return { id, passSubscription };
  }

  editPassSubscription(id, values) {
    return { id, values };
  }
}

export default alt.createActions(PassSubscriptionActions);



// WEBPACK FOOTER //
// ./src/app/actions/PassSubscriptionActions.js